export default {
    it: {
        "yes.text": "Si",
        "no.text": "No",
        "appointment.text": "Voglio prenotare un appuntamento",
        "contact.text": "Voglio essere ricontattato"
    },
    en: {
        "yes.text": "Yes",
        "no.text": "No",
        "appointment.text": "I want to book an appointment",
        "contact.text": "I want to be contacted"
    }
}